import { Button, Text } from '@civilgrid/ui/components';

type FetchErrorDisplayProps = {
  label: string;
  error: unknown;
  onRetry: () => void;
  /** SessionStorage key to clear when resetting filters. If omitted, the reset button is hidden. */
  filterStorageKey?: string;
};

export function FetchErrorDisplay({ label, error, onRetry, filterStorageKey }: FetchErrorDisplayProps) {
  return (
    <div className="flex h-screen-height-minus-top-nav flex-col items-center justify-center gap-4">
      <Text className="text-primary text-lg font-semibold">Failed to load {label}</Text>
      <Text className="text-secondary text-sm max-w-md text-center">
        {error instanceof Error ? error.message : `An unexpected error occurred while fetching ${label}.`}
      </Text>
      <div className="flex items-center gap-2">
        {filterStorageKey && (
          <Button
            variant="secondary"
            onClick={() => {
              sessionStorage.removeItem(filterStorageKey);
              window.location.reload();
            }}
          >
            Reset Filters & Reload
          </Button>
        )}
        <Button variant="primary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    </div>
  );
}
